<template>
  <div class="news-manage-page">
    <div class="news-manage-page__header">
      <h2 class="news-manage-page__title">企业管理</h2>
      <p class="news-manage-page__desc">管理发布页与商圈页的企业内容，支持筛选与批量操作</p>
    </div>

    <div class="toolbar-card">
      <el-form ref="params" :model="params" class="toolbar-card__form" inline @submit.native.prevent>
        <el-form-item prop="id">
          <el-input v-model="params.id" clearable placeholder="ID" style="width: 100px"/>
        </el-form-item>
        <el-form-item prop="title">
          <el-input v-model="params.title" clearable placeholder="搜索标题" prefix-icon="el-icon-search" style="width: 160px"/>
        </el-form-item>
        <el-form-item>
          <el-cascader
              :options="newsTypes"
              :props="{ checkStrictly: true }"
              :value="params.newsTypeId"
              clearable
              placeholder="企业类型"
              style="width: 160px"
              @change="newsTypeChange"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="params.isOpenMessage" clearable placeholder="下单功能" style="width: 110px">
            <el-option v-for="item in ocs" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="params.checkState" clearable placeholder="审核状态" style="width: 110px">
            <el-option v-for="item in checkStates" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="toolbar-card__actions">
        <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        <el-button icon="el-icon-plus" plain type="primary" @click="skipAddNews()">新增企业</el-button>
      </div>
    </div>

    <div class="main-card">
      <div class="filter-bar">
        <el-tabs v-model="stateValue" @tab-click="onStateTabClick">
          <el-tab-pane v-for="state in status" :key="state" :label="state" :name="state"/>
        </el-tabs>
      </div>

      <div class="table-wrap">
        <el-table
            v-loading="loadTable"
            :data="records"
            size="small"
            stripe
        >
          <el-table-column fixed label="ID" prop="id" width="80"/>
          <el-table-column fixed label="标题" min-width="180" prop="title" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="news-title">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="封面" width="72">
            <template slot-scope="scope">
              <el-image
                  v-if="scope.row.coverImg && scope.row.coverImg[0]"
                  :preview-src-list="scope.row.coverImg"
                  :src="scope.row.coverImg[0]"
                  class="cover-thumb"
                  fit="cover"
              />
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" min-width="100" prop="newsTypeName" show-overflow-tooltip/>
          <el-table-column label="浏览量" min-width="100">
            <template slot-scope="scope">
              <div class="look-num">
                {{ scope.row.lookNum || 0 }}
                <span v-if="scope.row.moreLookNum" class="look-num__extra">+{{ scope.row.moreLookNum }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="浏览量显示" width="96">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isShowLookNum == '1' ? 'success' : 'info'" size="mini">
                {{ scope.row.isShowLookNum == '1' ? '开启' : '关闭' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="发布人" min-width="120">
            <template slot-scope="scope">
              <span class="publisher-cell__name">{{ scope.row.promulgatorNickname || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="审核状态" width="96">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.checkState == '0'" type="warning" size="mini">审核中</el-tag>
              <el-tag v-else-if="scope.row.checkState == '1'" type="danger" size="mini">审核失败</el-tag>
              <el-tag v-else-if="scope.row.checkState == '2'" type="success" size="mini">审核通过</el-tag>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" prop="createdTime" show-overflow-tooltip/>
          <el-table-column label="修改时间" min-width="160" prop="updatedTime" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <div class="op-group">
                <el-button plain size="mini" type="primary" @click="skipAddNews(scope.row)">编辑</el-button>
                <el-dropdown trigger="click" @command="cmd => handleRowCommand(cmd, scope.row)">
                  <el-button size="mini">
                    更多<i class="el-icon-arrow-down el-icon--right"/>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="scope.row.checkState == '1'" command="checkReply">失败原因</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isShowLookNum === '1'" command="lookNumClose">关闭浏览量</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isShowLookNum === '0'" command="lookNumOpen">开启浏览量</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isShowCreatedTime === '1'" command="createdTimeClose">关闭时间</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isShowCreatedTime === '0'" command="createdTimeOpen">开启时间</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isOpenMessage == 1" command="viewMessage">查看下单</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isOpenMessage == 1" command="messageClose">关闭下单</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isOpenMessage == 0" command="messageOpen">开启下单</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isEnableVideoChat === '是'" command="videoChatClose">关闭通话</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isEnableVideoChat === '否'" command="videoChatOpen">开启通话</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isOpenLongpress === '是'" command="longpressClose">关闭长按菜单</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.isOpenLongpress === '否'" command="longpressOpen">开启长按菜单</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.state !== '1'" command="stateUp">上架</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.state === '1'" command="stateDown">下架</el-dropdown-item>
                    <el-dropdown-item command="history" divided>浏览记录</el-dropdown-item>
                    <el-dropdown-item command="transfer">转让</el-dropdown-item>

                    <el-dropdown-item v-if="scope.row.state !== '-1'" command="delete" divided>移入回收站</el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.state === '-1'" command="recover" divided>恢复</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <!-- 删除提示框 -->
    <el-dialog :visible.sync="showDel" title="操作确认" width="420px">
      <p>确认将 ID 为 <strong>{{ delId }}</strong> 的企业 {{ delState === '-1' ? '移入回收站' : '恢复' }}吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="doDel">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 下单功能 -->
    <el-dialog :visible.sync="showCloseNewsMessage" class="form-dialog" title="下单功能" width="480px">
      <p>确认{{ closeNewsMessage.state == '1' ? '开启' : '关闭' }} ID 为 <strong>{{ closeNewsMessage.id }}</strong> 的下单功能吗？</p>
      <el-form label-position="left" label-width="80px" :model="closeNewsMessage">
        <el-form-item label="下单模板">
          <el-select v-model="closeNewsMessage.messageTemplateId" placeholder="下单模板">
            <el-option
                v-for="item in messageTemplates"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCloseNewsMessage = false">取 消</el-button>
        <el-button type="primary" @click="doOpenCloseNewsMessage">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 上下架 -->
    <el-dialog :visible.sync="showChangeNewsState" title="操作确认" width="420px">
      <p>确认{{ changeNewsState.state == '1' ? '上架' : '下架' }} ID 为 <strong>{{ changeNewsState.id }}</strong> 的企业吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangeNewsState = false">取 消</el-button>
        <el-button type="primary" @click="doChangeNewsState">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 失败原因 -->
    <el-dialog :visible.sync="showCheckReply" title="审核失败原因" width="420px">
      <div class="check-reply-content">{{ checkReply }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCheckReply = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 转让 -->
    <el-dialog :visible.sync="showTransfer" class="form-dialog" title="转让企业" width="480px">
      <el-form label-position="left" label-width="130px" :model="transfer" ref="transferForm">
        <el-form-item label="用户类型" prop="userType"
                      :rules="[{ required: true, message: '请选择用户类型', trigger: 'blur' }]">
          <el-select v-model="transfer.userType" clearable placeholder="请选择用户类型">
            <el-option
                v-for="item in userTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户ID" prop="userId"
                      :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        { validator: notLtNum1, trigger: 'blur' }
                        ]">
          <el-input v-model.number="transfer.userId" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTransfer = false">取 消</el-button>
        <el-button type="primary" @click="doTransfer('transferForm')">确 定</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
import adminGetNews from "@/api/user/admin-controler/adminGetNews";
import adminGetNewsType from "@/api/user/admin-controler/adminGetNewsType";
import {Message} from "element-ui";
import Page from "@/components/Page";
import adminOpenCloseNewsMessage from "@/api/user/admin-controler/adminOpenCloseNewsMessage";
import adminChangeNewsState from "@/api/user/admin-controler/adminChangeNewsState";
import adminOpenCloseNewsLookNum from "@/api/user/admin-controler/adminOpenCloseNewsLookNum";
import agencyGetNewsMessageTemplates from "@/api/user/agency/agencyGetNewsMessageTemplates";
import agencyOpenCloseVideoChat from "@/api/user/agency/agencyOpenCloseVideoChat";
import {notLtNum1} from "@/utils/check";
import transfer from "@/api/news/news/transfer";
import openCloseNewsCreatedTime from "@/api/news/news/openCloseNewsCreatedTime";
import changeIsOpenLongpress from "@/api/news/news/changeIsOpenLongpress";


export default {
  name: "NewsManage",
  components: {Page},
  data() {
    return {
      current: 1,
      size: 10,
      total: 0,

      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,

      state: '1',
      params: {
        id: this.$route.query.id || undefined,
        title: undefined,
        newsTypeId: undefined,
        isOpenMessage: undefined,
        state: undefined,
        checkState: undefined,
      },
      userTypes: [
        { value: 'agency', label: '代理商' },
        { value: 'merchant', label: '合伙人' },
      ],
      newsTypes: [],
      ocs: [
        { value: 1, label: '开启' },
        { value: 0, label: '关闭' },
      ],
      status: ['上架', '下架', '回收站'],
      stateValue: '上架',
      checkStates: [
        { value: '0', label: '审核中' },
        { value: '1', label: '审核失败' },
        { value: '2', label: '审核成功' },
      ],

      loadTable: false,
      records: [],

      delId: undefined,
      delState: undefined,
      showDel: false,

      messageTemplates: [],
      closeNewsMessage: {
        id: undefined,
        state: undefined,
        messageTemplateId: undefined,
      },
      showCloseNewsMessage: false,

      showChangeNewsState: false,
      changeNewsState: {
        id: undefined,
        state: undefined,
      },

      showCheckReply: false,
      checkReply: undefined,

      showTransfer: false,
      transfer: {
        id: undefined,
        userType: undefined,
        userId: undefined,
      },


    }
  },



  methods: {
    notLtNum1,

    onStateTabClick(tab) {
      if (tab.label === '上架') {
        this.state = '1'
      } else if (tab.label === '下架') {
        this.state = '0'
      } else if (tab.label === '回收站') {
        this.state = '-1'
      }
      this.reset()
    },

    handleRowCommand(cmd, row) {
      switch (cmd) {
        case 'checkReply':
          this.onShowCheckReply(row.checkReply)
          break
        case 'lookNumClose':
          this.onOpenCloseNewsLookNum(row.id, '0')
          break
        case 'lookNumOpen':
          this.onOpenCloseNewsLookNum(row.id, '1')
          break
        case 'createdTimeClose':
          this.onOpenCloseNewsCreatedTime(row.id, '0')
          break
        case 'createdTimeOpen':
          this.onOpenCloseNewsCreatedTime(row.id, '1')
          break
        case 'viewMessage':
          this.skipNewsMessage(row)
          break
        case 'messageClose':
          this.onOpenCloseNewsMessage(row, '0')
          break
        case 'messageOpen':
          this.onOpenCloseNewsMessage(row, '1')
          break
        case 'videoChatClose':
          this.doOpenCloseVideChat(row, '否')
          break
        case 'videoChatOpen':
          this.doOpenCloseVideChat(row, '是')
          break
        case 'longpressClose':
          this.doChangeIsOpenLongpress(row, '否')
          break
        case 'longpressOpen':
          this.doChangeIsOpenLongpress(row, '是')
          break
        case 'stateUp':
          this.onChangeNewsState(row.id, '1')
          break
        case 'stateDown':
          this.onChangeNewsState(row.id, '0')
          break
        case 'history':
          this.skipToNewsHistory(row)
          break
        case 'transfer':
          this.onShowTransfer(row)
          break

        case 'delete':
          this.onShowDel(row, '-1')
          break
        case 'recover':
          this.onShowDel(row, '0')
          break
      }
    },

    doTransfer(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          transfer(this.transfer.id, this.transfer.userType, this.transfer.userId).then(res => {
            if (res.code === 1) {
              Message({message: '成功', type: "success", duration: 3000})
              this.showTransfer = false
              this.fetchData()
            } else {
              Message({message: '失败', type: "error", duration: 3000})
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },

    onShowTransfer(row) {
      this.transfer = {
        id: row.id,
        userType: row.userType,
        userId: row.userId,
      }
      this.showTransfer = true
    },

    onShowCheckReply(checkReply) {
      this.checkReply = checkReply
      this.showCheckReply = true
    },

    newsTypeChange(e) {
      if (!e || e.length === 0) {
        this.params.newsTypeId = undefined
      } else {
        this.params.newsTypeId = e[e.length - 1]
      }
    },

    doChangeNewsState() {
      adminChangeNewsState(this.changeNewsState.id, this.changeNewsState.state).then(res => {
        if (res.code == 1) {
          Message({message: "成功", type: "success", duration: 3000})
          this.showChangeNewsState = false
          this.fetchData()
        } else {
          if (res.data && res.data.illError) {
            Message({message: res.data.illError, type: "error", duration: 3000})
            return
          }
          Message({message: res.msg, type: "error", duration: 3000})
        }
      })
    },

    skipAddNews(row) {
      const routeData = this.$router.resolve({
        name: "企业编辑",
        query: {id: row ? row.id : ""}
      });
      window.open(routeData.href, '_blank');
    },

    skipNewsMessage(row) {
      localStorage.setItem("newsId", row.id)
      this.$router.push({name: "企业下单"})
    },

    doOpenCloseNewsMessage() {
      if (!this.closeNewsMessage.messageTemplateId) {
        return Message({message: '请选择模板', type: 'error', duration: 3000})
      }
      adminOpenCloseNewsMessage(this.closeNewsMessage.id, this.closeNewsMessage.state, this.closeNewsMessage.messageTemplateId).then(res => {
        if (res.code == 1) {
          Message({message: '成功', type: 'success', duration: 3000})
          this.showCloseNewsMessage = false
          this.fetchData()
        }
      })
    },

    onOpenCloseNewsLookNum(id, isShowLookNum) {
      adminOpenCloseNewsLookNum(id, isShowLookNum).then(res => {
        if (res.code == 1) {
          Message({message: '成功', type: "success", duration: 3000})
          this.fetchData()
        } else {
          Message({message: '失败', type: "error", duration: 3000})
        }
      })
    },

    onOpenCloseNewsCreatedTime(id, isShowCreatedTime) {
      openCloseNewsCreatedTime(id, isShowCreatedTime).then(res => {
        if (res.code == 1) {
          Message({message: '成功', type: "success", duration: 3000})
          this.fetchData()
        } else {
          Message({message: '失败', type: "error", duration: 3000})
        }
      })
    },

    onOpenCloseNewsMessage(row, state) {
      agencyGetNewsMessageTemplates().then(res => {
        let data = res.data
        let arr = []
        for (let i = 0; i < data.length; i++) {
          arr.push({value: data[i].id, label: data[i].name})
        }
        this.messageTemplates = arr
        if (this.messageTemplates.length === 0) {
          Message({message: '请先向平台申请下单模板!', type: 'error', duration: 3000})
          this.fetchData()
          return
        } else {
          this.closeNewsMessage.state = state
          this.closeNewsMessage.id = row.id
          let flag = false
          for (let i = 0; i < this.messageTemplates.length; i++) {
            if (this.messageTemplates[i].value === row.messageTemplateId) {
              flag = true
              break
            }
          }
          if (flag) {
            this.closeNewsMessage.messageTemplateId = row.messageTemplateId
          } else {
            this.closeNewsMessage.messageTemplateId = undefined
          }
          this.showCloseNewsMessage = true
        }
      })
    },

    doOpenCloseVideChat(row, state) {
      agencyOpenCloseVideoChat(row.id, state).then(res => {
        if (res.code != 1) {
          if (res.data && res.data.illError) {
            Message({message: res.data.illError, type: 'error', duration: 3000});
          } else {
            Message({message: res.msg, type: 'error', duration: 3000});
          }
        } else {
          Message({message: '成功', type: 'success', duration: 3000});
          this.fetchData()
        }
      })
    },

    doChangeIsOpenLongpress(row, isOpenLongpress) {
      const params = {id: row.id, isOpenLongpress: isOpenLongpress}
      changeIsOpenLongpress(params).then(res => {
        if (res.code != 1) {
          Message({message: '失败', type: 'error', duration: 3000});
        } else {
          Message({message: '成功', type: 'success', duration: 3000});
          this.fetchData()
        }
      })
    },

    onChangeNewsState(id, state) {
      this.showChangeNewsState = true
      this.changeNewsState.id = id
      this.changeNewsState.state = state
    },

    doDel() {
      adminChangeNewsState(this.delId, this.delState).then(res => {
        if (res.code != 1) {
          Message({message: '失败', type: 'error', duration: 3000});
        } else {
          Message({message: '成功', type: 'success', duration: 3000});
          this.showDel = false
          this.fetchData()
        }
      })
    },

    onShowDel(row, state) {
      this.delId = row.id
      this.delState = state
      this.showDel = true
    },

    skipToNewsHistory(row) {
      localStorage.setItem("newsHistoryId", row.id);
      this.$router.push({name: "浏览记录"})
    },

    reset() {
      this.current = 1
      this.size = 10
      this.params = {}
      this.fetchData()
    },

    search() {
      this.current = 1
      this.size = 10
      this.fetchData()
    },

    getMessageTemplates() {
      agencyGetNewsMessageTemplates().then(res => {
        let data = res.data
        let arr = []
        for (let i = 0; i < data.length; i++) {
          arr.push({value: data[i].id, label: data[i].name})
        }
        this.messageTemplates = arr
      })
    },

    getNewsType() {
      adminGetNewsType().then(res => {
        let types = res.data
        types.sort((a, b) => a.order - b.order)

        let map = new Map()
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if (type.parentId == 0) continue
          let children = map.get(type.parentId)
          if (!children) {
            children = []
          }
          children.push({value: type.id, label: type.name})
          map.set(type.parentId, children)
        }

        let data = []
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if (type.parentId > 0) continue
          if (map.has(type.id)) {
            type.children = map.get(type.id)
          }
          data.push({
            value: type.id,
            label: type.name,
            children: type.children
          })
        }

        this.newsTypes = data
      })
    },

    getNews() {
      this.params.state = this.state
      adminGetNews(this.current, this.size, this.params).then(res => {
        let records = res.data.data
        this.total = res.data.total
        for (let i = 0; i < records.length; i++) {
          let coverImg = records[i].coverImg
          records[i].coverImg = [this.fileBaseUrl + coverImg]
        }
        this.records = records
      })
    },

    fetchData() {
      this.getNews()
    },


  },

  mounted() {
    this.getNewsType()
    this.getMessageTemplates()
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped>
@import "NewsManage";
</style>
